module.exports = __webpack_public_path__ + "a28bb74c125e20934c89f16dfd2fbbe5.png";